// extracted by mini-css-extract-plugin
module.exports = {"feedback-form":"Feedback_feedback-form__gjZuZ","label":"Feedback_label__23fua","input":"Feedback_input__gnfmm","button":"Feedback_button__dYkFu"};